/**
 * We use translations schemas from sanity in main app code for two purposes:
 * 1. define typings for translations
 * 2. get default values for translations
 */
import * as tSchemas from './index';

export const defaultTranslations = {
	search: tSchemas.BuyeasySearchTranslations.fields,
	userProperties: tSchemas.BuyeasyUserPropertiesTranslations.fields,
	store: tSchemas.BuyeasyStoreTranslations.fields,
	storeHowToBuyButton: tSchemas.BuyeasyHowToBuyButtonTranslations.fields,
	supplierHeader: tSchemas.BuyeasySupplierHeaderTranslations.fields,
	supplierRelated: tSchemas.BuyeasySupplierRelatedTranslations.fields,
	supplierReviews: tSchemas.BuyeasySupplierReviewsTranslations.fields,
	supplierTprm: tSchemas.BuyeasySupplierTprmTranslations.fields,
	supplierPreferredCategories: tSchemas.BuyeasySupplierPreferredCategoriesTranslations.fields,
	supplierUserProperties: tSchemas.BuyeasySupplierUserPropertiesTranslations.fields,
	supplierInformation: tSchemas.BuyeasySupplierInformationTranslations.fields,
	wizard: tSchemas.BuyeasyBuyingWizardTranslations.fields,
	wizardStepper: tSchemas.BuyeasyStepperTranslations.fields,
	wizardCategoryStep: tSchemas.BuyeasyCategoryStepTranslations.fields,
	wizardGuidanceStep: tSchemas.BuyeasyGuidanceStepTranslations.fields,
	wizardResultsStep: tSchemas.BuyeasyResultsStepTranslations.fields,
	wizardValueStep: tSchemas.BuyeasyValueStepTranslations.fields,
} as const;

export type Translations = typeof defaultTranslations;
